module.exports = __webpack_public_path__ + "static/a1-7c4f0d79f471df7015236a999cb8327a.png";